require('react-app-polyfill/ie11');
require('react-app-polyfill/stable');
require('intersection-observer');
require('eventlistener-polyfill');
require('navigator.locks');

// Polyfill: Element.prototype.matches
if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector
    || Element.prototype.webkitMatchesSelector;
}

// Polyfill: Element.prototype.closest
if (!Element.prototype.closest) {
  Element.prototype.closest = function closest(selector) {
    let node = this;

    while (node) {
      if (node.matches(selector)) return node;
      node = node.parentElement;
    }

    return null;
  };
}
